export enum LiveLectureTypeEnum {
  SOLO = "SOLO",
  GROUP = "GROUP",
  THERAPY = "THERAPY",
}
